import { createRestSlice } from "./restSlice";

export type OrganizationPhoneNumber = {
  id: string;
  organizationId: string;
  phoneNumber: string;
  telephonyId: string;
  friendlyName: string;
  areaCode: string;
  countryCode: string;
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
};

const organizationPhoneNumberSlice = createRestSlice<OrganizationPhoneNumber>("organizationPhoneNumbers", "/v1/organizations/:organizationId/phoneNumbers");

export const organizationPhoneNumberReducer = organizationPhoneNumberSlice.reducer;
export const organizationPhoneNumberActions = organizationPhoneNumberSlice.actions;
